import axios from "axios";
import { SERVER_URL } from "Constants";

export async function requestCustomerAlaresReport(customerId: string) {
	return await axios.get(`${SERVER_URL}/api/entity/AlaresReportEntity/report/customer/${customerId}/new`);
}

export async function requestAddMonitorToAlaresWatchlist(entityId: string) {
	return await axios.get(`${SERVER_URL}/api/entity/MonitoredEntity/alares/watchlist/${entityId}`);
}